import Vue from 'vue'
import searchesMutations from './mutationTypes'
import defaultFilters from '../../../constants/searchFilters'
import _ from 'lodash'

const mutations = {
  [searchesMutations.SET_SAVED_SEARCHES] (state, response) {
    state.savedSearches = response.data
  },
  [searchesMutations.SET_SEARCH_FIELDS] (state, fields) {
    state.fields = fields
  },
  [searchesMutations.SET_QUESTIONS] (state, questions) {
    state.studyMapping = questions
  },
  [searchesMutations.SET_CICS] (state, cics) {
    state.cics = cics
  },
  [searchesMutations.SET_SEARCH_FILTERS] (state, filters) {
    state.filterValues = filters
  },
  [searchesMutations.APPLY_SEARCH_FILTERS] (state, newFilters) {
    let filters = _.cloneDeep(defaultFilters.getInitialFilters())
    Object.keys(newFilters).forEach(category => {
      if (category === 'metrics' && newFilters[category].metricsList.length === 0) {
        delete newFilters[category].metricsList
      }
      // this is to prevent not loading old saved searches due to no confidence value
      if (category === 'metrics' && newFilters[category].metricsList) {
        newFilters[category].metricsList.forEach(metric => {
          if (!metric.confidence) {
            metric.confidence = {
              key: 'confidence',
              label: 'Confidence',
              value: false
            }
          }
        })
      }
      filters[category] = {
        ...filters[category],
        ...newFilters[category]
      }
    })
    state.filterValues = filters
  },
  [searchesMutations.SET_CICS_FILTERS] (state, filters) {
    state.cicsFilterValues = filters
  },
  [searchesMutations.APPLY_CICS_FILTERS] (state, newFilters) {
    let filters = _.cloneDeep(defaultFilters.getInitialFilters())
    const parsedFilters = JSON.parse(newFilters.metadata_query)
    Object.keys(parsedFilters).forEach(category => {
      filters[category] = {
        ...filters[category],
        ...parsedFilters[category]
      }
    })
    state.cicsFilterValues = filters
  },
  [searchesMutations.RESET_SEARCH_FILTERS] (state) {
    state.filterValues = Object.assign(state.filterValues, defaultFilters.getInitialFilters())
  },
  [searchesMutations.SET_JOB_ID] (state, obj) {
    state.analyticsJobIds[obj.job] = obj.id
  },
  [searchesMutations.RESET_CICS_FILTERS] (state) {
    state.cicsFilterValues = Object.assign(state.cicsFilterValues, defaultFilters.getInitialFilters())
  },
  [searchesMutations.SET_STUDY_SUMMARIES] (state, data) {
    state.summaries = data
  },
  [searchesMutations.SET_ANALYTICS_DATA] (state, obj) {
    state.analytics[obj.type] = obj.data
  },
  [searchesMutations.SET_FRAGRANCES] (state, data) {
    state.fragrances = data
  },
  [searchesMutations.SET_FRAGRANCES_DETAILS] (state, data) {
    state.studyDetails.fragrance_details = data
  },
  [searchesMutations.SET_CONCEPTS] (state, data) {
    state.concepts = data
  },
  [searchesMutations.SET_CONCEPTS_DETAILS] (state, data) {
    state.studyDetails.concepts = data
  },
  [searchesMutations.SET_FILES] (state, { fileType, data }) {
    state.files[fileType] = data
  },
  [searchesMutations.CLEAR_ANALYTICS] (state) {
    state.analytics = {
      metrics: {},
      attributes: {},
      tendencies: {},
      performance: {}
    }
  },
  [searchesMutations.CLEAR_STUDY_SUMMARIES] (state) {
    state.summaries = []
  },
  [searchesMutations.CLEAR_FRAGRANCES] (state) {
    state.fragrances = []
  },
  [searchesMutations.CLEAR_CONCEPTS] (state) {
    state.concepts = []
  },
  [searchesMutations.CLEAR_FILES] (state) {
    state.files = {
      report: [],
      questionnaire: [],
      protocol: [],
      RDF: [],
      screener: []
    }
  },
  [searchesMutations.SET_STUDY_DETAILS] (state, response) {
    state.studyDetails = { ...state.studyDetails, ...response }
  },
  [searchesMutations.SET_STUDY_TAGS] (state, response) {
    state.studyDetails.tags = response
  },
  [searchesMutations.UPDATE_STUDY_DETAILS] (state, response) {
    const metadata = state.studyDetails.metadata
    const metadataKeys = Object.keys(metadata)
    const newKeys = Object.keys(response)
    newKeys.forEach(key => {
      metadataKeys.forEach(metadataKey => {
        if (Object.keys(metadata[metadataKey]).includes(key)) {
          Vue.set(metadata[metadataKey][key], 'value', response[key])
        }
      })
    })
  },
  [searchesMutations.SET_STUDIES_COUNT] (state, response) {
    state.studyCount = response.data
  },
  [searchesMutations.SET_STUDY_ERROR] (state, error) {
    Vue.set(state, 'studyError', error)
  },
  [searchesMutations.SET_SIGNIFICANCE_RESULTS] (state, data) {
    console.log('data', data)
    console.log('state', state)
    state.significance.results = data
  }
}

export default {
  ...mutations
}
